"use strict";
'use es6';

require("i18n-data/static-1.70/data/currency");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/init/data/currency.js
// module id = 618
// module chunks = 209 210 211 212